import { useMemo } from 'react'
import { useQuery } from '@based/sdk/react'
import { MunicipalityViewModel } from 'functions/app/geography/view/municipality'
import { isFeatureEnabled } from '@app/util/featureToggle'
import { municipalityTabs } from '../constants'
import type { MunicipalityFeatures } from '@schema/featureToggle'
import {
  isMunicipalityLayoutTabAvailable,
  type MunicipalityLayoutTabAvailabilityContext,
} from './isMunicipalityLayoutTabAvailable'

export const useMunicipalityLayoutTabAvailability = (
  municipality: MunicipalityViewModel,
) => {
  const expertsFeatureEnabled = isFeatureEnabled(
    municipality.featureToggles,
    municipalityTabs.experts,
  )

  const expertsCountQuery = useQuery(
    expertsFeatureEnabled ? 'list-regional-service-providers' : null,
    { municipalityId: municipality.id, count: true },
  )

  const context: MunicipalityLayoutTabAvailabilityContext = useMemo(
    () => ({
      expertsCount: expertsCountQuery.data?.count ?? 0,
    }),
    [expertsCountQuery.data?.count],
  )

  const isTabAvailable = (tab: MunicipalityFeatures) =>
    isMunicipalityLayoutTabAvailable(municipality, tab, context)

  return { isTabAvailable, context }
}
